import {getLanguageAwareURL} from '../utilities/get-language-aware-url';

export const getAfterLanguageChangeURL = (
    currentURL: string,
    lang: string
): string => {
    const _currentURL = new URL(currentURL);
    return getLanguageAwareURL(_currentURL.pathname, lang, _currentURL.search);
};
